import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function MobileBottomNav({ items, baseColor = 'sky' }) {
  const location = useLocation();

  const colorClasses = {
    sky: {
      active: 'text-sky-600 dark:text-sky-400',
      inactive: 'text-slate-400 dark:text-slate-500',
      activeBg: 'bg-sky-50 dark:bg-sky-900/30',
    },
    emerald: {
      active: 'text-emerald-600 dark:text-emerald-400',
      inactive: 'text-slate-400 dark:text-slate-500',
      activeBg: 'bg-emerald-50 dark:bg-emerald-900/30',
    },
    purple: {
      active: 'text-purple-600 dark:text-purple-400',
      inactive: 'text-slate-400 dark:text-slate-500',
      activeBg: 'bg-purple-50 dark:bg-purple-900/30',
    },
    amber: {
      active: 'text-amber-600 dark:text-amber-400',
      inactive: 'text-slate-400 dark:text-slate-500',
      activeBg: 'bg-amber-50 dark:bg-amber-900/30',
    },
  };

  const colors = colorClasses[baseColor] || colorClasses.sky;

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-800 lg:hidden safe-area-bottom"
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-center justify-around h-16 px-2">
        {items.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path || 
            (item.matchPaths && item.matchPaths.some(p => location.pathname.startsWith(p)));

          return (
            <NavLink
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 h-full px-1 py-2 transition-all duration-200 ${
                isActive ? colors.activeBg : ''
              }`}
              data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className={`p-1.5 rounded-xl transition-all duration-200 ${
                isActive ? colors.activeBg : ''
              }`}>
                <Icon 
                  className={`w-5 h-5 transition-colors ${
                    isActive ? colors.active : colors.inactive
                  }`}
                  strokeWidth={isActive ? 2 : 1.5}
                />
              </div>
              <span className={`text-[10px] font-medium mt-0.5 transition-colors ${
                isActive ? colors.active : colors.inactive
              }`}>
                {item.label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
